import Aos from 'aos';
import React, { useEffect } from 'react'

const formatYear = (year) => {
	return year.split("/").map((part, index) => (
		<span key={index}>
			{index > 0 && <span className='text-neon text-xl font-semibold'> / </span>}
			{part}
		</span>
	));
};

const AchievementList = ({ achievement }) => {
	useEffect(() => {
		Aos.init({ duration: 500 });
	}, []);

	return (
		<li data-aos="zoom-in-up" data-aos-offset="100">
			<div className="achIndex">{achievement.index}</div>
			<div className="achDate">{formatYear(achievement.date)}</div>
			<div className="achTitle" data-value={achievement.title}>{achievement.title}</div>
			<div className="achDescription">{achievement.desp}</div>
			<div className="achImg">
				<img src={achievement.imageUrl} alt={`${achievement.title} pic`} className="img-fluid" />
			</div>
		</li>
	);
};

export default AchievementList